import React from "react";

import Arrow from "../../../../static/images/arrow.svg";
import IconContinue from "../../../../static/images/icon-continue.svg";

const StepButtons = ({ nextStep, previousStep, last }) => (
  <div
    className={`${baseClass} justify-content-${
      previousStep ? "evenly" : "end"
    }`}
  >
    {previousStep && (
      <button className="back-button" onClick={previousStep}>
        <img src={Arrow} alt="Atrás" /> Atrás
      </button>
    )}
    <button className="next-button" onClick={nextStep}>
      {!last ? "Continuar" : "Finalizar"}
      <img src={IconContinue} alt="Continue" />
    </button>
  </div>
);

export default StepButtons;

const baseClass = "d-flex step-buttons w-100";
